// extracted by mini-css-extract-plugin
module.exports = {"customSignIn":"customSignIn_18kPV","spinner":"spinner_21hdh","password":"password_2Hk8d","submit":"submit_Nhhkb"};